import React from 'react';
import { HOUSING_TYPES } from './constants';

// Satır tanımları: en altta "şimdi ödenecek" olan ön başvuru bedeli vurgulanır
const SATIRLAR = [
  { etiket: 'Peşinat', alan: 'pesinat', vurgulu: false },
  { etiket: 'Aidat', alan: 'aidat', vurgulu: false },
  { etiket: 'Ön Başvuru Bedeli', alan: 'onBasvuruBedeli', vurgulu: true }
];

/**
 * Konut tiplerine göre ödeme tablosu.
 * secili: seçili konut tipinin kodu (opsiyonel) — ilgili sütun öne çıkarılır.
 */
const PricingTable = ({ secili, onSelect }) => {
  const secilebilir = typeof onSelect === 'function';

  return (
    <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full min-w-107.5 border-collapse text-sm">
          <thead>
            <tr>
              <th className="bg-primary-dark text-white text-left font-bold uppercase tracking-wide text-xs px-3 py-3 w-[38%]">
                Ödeme
              </th>
              {HOUSING_TYPES.map((tip) => {
                const aktif = secili === tip.kod;

                return (
                  <th
                    key={tip.kod}
                    onClick={secilebilir ? () => onSelect(tip.kod) : undefined}
                    className={`
                      bg-primary text-white px-2 py-3 text-center align-middle
                      border-l border-white/20
                      ${secilebilir ? 'cursor-pointer' : ''}
                    `}
                  >
                    <span className="block text-base font-bold leading-none">{tip.metrekare}</span>
                    <span className="block text-[11px] font-medium opacity-90 mt-1">
                      {tip.konsept} · {tip.daireSayisi} daire
                    </span>
                    {aktif && (
                      <span className="mt-1.5 inline-flex items-center gap-1 bg-white/25 rounded-full px-2 py-0.5 text-[10px] font-bold">
                        <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" />
                        </svg>
                        Seçili
                      </span>
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {SATIRLAR.map((satir) => (
              <tr key={satir.alan} className={satir.vurgulu ? 'border-t-2 border-gray-300' : 'border-t border-gray-200'}>
                <th
                  scope="row"
                  className={`
                    text-left px-3 py-3 font-semibold border-r border-gray-200
                    ${satir.vurgulu ? 'bg-gray-100 text-gray-900' : 'bg-gray-50 text-gray-700'}
                  `}
                >
                  {satir.etiket}
                  {satir.vurgulu && (
                    <span className="block text-[10px] font-medium text-primary mt-0.5">
                      Şimdi ödenecek
                    </span>
                  )}
                </th>

                {HOUSING_TYPES.map((tip) => {
                  const aktif = secili === tip.kod;

                  return (
                    <td
                      key={tip.kod}
                      onClick={secilebilir ? () => onSelect(tip.kod) : undefined}
                      className={`
                        px-2 py-3 text-center whitespace-nowrap border-r border-gray-200 last:border-r-0
                        ${aktif ? 'bg-primary-light' : 'bg-white'}
                        ${satir.vurgulu
                          ? 'font-bold text-[15px] text-primary'
                          : 'font-medium text-gray-700'
                        }
                        ${secilebilir ? 'cursor-pointer' : ''}
                      `}
                    >
                      {tip[satir.alan]}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="bg-gray-50 border-t border-gray-200 px-3 py-2.5 text-[11px] text-gray-500 leading-relaxed">
        Peşinat ve aidat bedelleri bu aşamada tahsil edilmez; kesin üyelik sonrasında ayrıca alınacaktır.
      </p>
    </div>
  );
};

export default PricingTable;
